import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-632cfa55")

_pushScopeId("data-v-632cfa55")
const _hoisted_1 = {
  class: "toc_ui__baseInfo_main",
  id: "carInfo"
}
const _hoisted_2 = { class: "toc_ui__baseInfo_body" }
const _hoisted_3 = { class: "toc_ui__baseInfo_body_cont" }
const _hoisted_4 = { class: "ui__comTitle_main" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "ui__comTitle_left" }, "电池管理系统信息", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 查看更多 ")
const _hoisted_7 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-youjiantou" }, null, -1)
const _hoisted_8 = { class: "infoList_main" }
const _hoisted_9 = { class: "infoList_item_value" }
const _hoisted_10 = {
  key: 0,
  class: "infoList_item_value_txt"
}
const _hoisted_11 = { class: "infoTxt" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "iconfont icon-yiwen" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode("此里程数仅为检测时表显里程")
const _hoisted_15 = {
  key: 1,
  class: "infoList_item_value_txt"
}
const _hoisted_16 = { class: "infoList_item_label" }
const _hoisted_17 = { class: "toc_ui__baseInfo_imgList" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", {
            class: "titleSlot",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBatterySystem && _ctx.goBatterySystem(...args)))
          }, [
            _hoisted_6,
            _hoisted_7
          ])
        ]),
        _createVNode("div", _hoisted_8, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.baseInfo, (item) => {
            return (_openBlock(), _createBlock("div", {
              class: "infoList_item",
              key: item.code
            }, [
              _createVNode("div", _hoisted_9, [
                (item.value)
                  ? (_openBlock(), _createBlock("div", _hoisted_10, [
                      _createVNode("div", _hoisted_11, _toDisplayString(item.value), 1),
                      (item.code === "mileage" || item.code === "mileageKilometers")
                        ? (_openBlock(), _createBlock("div", {
                            key: 0,
                            class: "qs",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(() => {_ctx.state.showTip = true}, ["stop"]))
                          }, [
                            _hoisted_12,
                            _withDirectives(_createVNode("span", null, [
                              _hoisted_13,
                              _hoisted_14
                            ], 512), [
                              [_vShow, _ctx.state.showTip]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_15, "-"))
              ]),
              _createVNode("div", _hoisted_16, _toDisplayString(item.name), 1)
            ]))
          }), 128))
        ]),
        _createVNode("ul", _hoisted_17, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.photoList.slice(0, 4), (item, index) => {
            return (_openBlock(), _createBlock("li", {
              class: "toc_ui__baseInfo_imgList_item",
              key: index
            }, [
              _createVNode("img", {
                class: "toc_ui__baseInfo_imgList_item",
                src: item.additionUrl,
                onClick: ($event: any) => (_ctx.goToImgView(item))
              }, null, 8, ["src", "onClick"]),
              (_ctx.state.photoList.length > 4 && index === 3)
                ? (_openBlock(), _createBlock("span", {
                    key: 0,
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToImgView("all")))
                  }, _toDisplayString(_ctx.state.photoList.length) + "张", 1))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
})